module.exports = "<div id=\"app-root\" [attr.theme]=\"theme\">\n    <busy-state name='global' cssClass=\"global\"></busy-state>\n    <disabled-dashboard></disabled-dashboard>\n    <error-list></error-list>\n\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main